// src/pages/ForgotPassword.js
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Space,
  Typography,
  message,
} from "antd";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { passwordRequest } from "@directus/sdk";
import client from "../helpers/directusClient";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState("");

  const onFinish = async (values) => {
    setLoading(true);
    const resetUrl = `${window.location.origin}/reset-password`;
    try {
      await client.request(passwordRequest(values.email, resetUrl));
      setSubmittedEmail(values.email);
      setSubmitted(true);
    } catch (error) {
      console.error("Password request error:", error);
      // Directus normally returns 204 even for unknown emails, so a thrown
      // error here usually means the reset URL isn't in the server's
      // PASSWORD_RESET_URL_ALLOW_LIST or SMTP isn't configured.
      message.error(
        "Could not send reset email. Please contact your administrator."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "0 15px",
      }}
    >
      <Col xs={24} sm={20} md={16} lg={12} xl={8}>
        <Card
          hoverable
          style={{
            borderRadius: 12,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
          }}
          bodyStyle={{ padding: "40px 32px" }}
        >
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <img
              src="/images/logo.png"
              alt="KwachaPlus"
              style={{
                height: 96,
                maxWidth: "100%",
                marginBottom: 24,
                borderRadius: 8,
              }}
            />
            <Title level={2} style={{ marginBottom: 8, color: "#2D3748" }}>
              Forgot Password
            </Title>
            <Text type="secondary" style={{ fontSize: 14 }}>
              Enter your email and we'll send you a reset link.
            </Text>
          </div>

          {submitted ? (
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <Alert
                message="Check your email"
                description={
                  <>
                    If an account exists for <b>{submittedEmail}</b>, a password
                    reset link has been sent. The link expires shortly, so use
                    it soon.
                  </>
                }
                type="success"
                showIcon
              />
              <div style={{ textAlign: "center" }}>
                <Link
                  to="/login"
                  style={{ color: "#667eea", fontWeight: 500 }}
                >
                  <ArrowLeftOutlined /> Back to sign in
                </Link>
              </div>
            </Space>
          ) : (
            <Form
              name="forgotPasswordForm"
              layout="vertical"
              autoComplete="off"
              onFinish={onFinish}
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email." },
                  { type: "email", message: "Enter a valid email address." },
                ]}
                style={{ marginBottom: 24 }}
              >
                <Input
                  prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                  placeholder="Enter email"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 16 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                  style={{
                    height: 48,
                    borderRadius: 8,
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    border: "none",
                    fontWeight: 600,
                  }}
                >
                  Send Reset Link
                </Button>
              </Form.Item>

              <div style={{ textAlign: "center" }}>
                <Link
                  to="/login"
                  style={{ color: "#667eea", fontSize: 14, fontWeight: 500 }}
                >
                  <ArrowLeftOutlined /> Back to sign in
                </Link>
              </div>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default ForgotPassword;
